// Module
var code = " <div class=\"controls\"> <div class=\"handles-container\"></div> </div> <div class=\"guides\"> <div class=\"guides-container\"></div> </div> <div class=\"component-content\"> <div class=\"component-style content\"></div> </div> ";
// Exports
export default code;